var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.31294 0 5.26062 2.53835 4.3418 5.94727C1.78009 7.28157 0 9.92007 0 13C0 17.4064 3.59356 21 8 21H11V24H13V17.4141L17.707 12.707L16.293 11.293L13 14.5859V6H11V12.5859L7.70703 9.29297L6.29297 10.707L11 15.4141V19H8C4.67444 19 2 16.3256 2 13C2 10.5536 3.4586 8.46565 5.54688 7.52734L6.01758 7.31641L6.11914 6.8125C6.66989 4.06903 9.08225 2 12 2C14.9177 2 17.3301 4.06903 17.8809 6.8125L17.9824 7.31641L18.4531 7.52734C20.5414 8.46565 22 10.5536 22 13C22 16.3256 19.3256 19 16 19H15V21H16C20.4064 21 24 17.4064 24 13C24 9.92007 22.2199 7.28157 19.6582 5.94727C18.7394 2.53835 15.6871 0 12 0Z",
    fill: "#1976d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12V28.5625L5.71875 23.2812L4.28125 24.7188L11.2812 31.7188L12 32.4062L12.7188 31.7188L19.7188 24.7188L18.2812 23.2812L13 28.5625V12H11Z",
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTree);
export default __webpack_public_path__ + "static/media/downloadTree.efce4ccea37917a76bd1b5a015fa29ac.svg";
export { ForwardRef as ReactComponent };